import type { RefObject } from 'react';

import { useVirtualizer, notUndefined } from '@tanstack/react-virtual';

const CELL_HEIGHT = 31;

const OVERSCAN = 5;
interface Props {
  rowsCount: number;
  scrollRef: RefObject<HTMLElement | null>;
  /** Initial per-row size guess; refined on the fly via `measureElement`. */
  estimateSize?: number;
  overscan?: number;
}
export const useVirtualRows = ({
  rowsCount,
  scrollRef,
  estimateSize = CELL_HEIGHT,
  overscan = OVERSCAN,
}: Props) => {
  const rowVirtualizer = useVirtualizer({
    count: rowsCount,
    getScrollElement: () => scrollRef.current,
    estimateSize: () => estimateSize,
    overscan,
  });

  const virtualRows = rowVirtualizer.getVirtualItems();
  const [before, after] =
    virtualRows.length > 0
      ? [
          notUndefined(virtualRows[0]).start -
            rowVirtualizer.options.scrollMargin,
          rowVirtualizer.getTotalSize() -
            notUndefined(virtualRows[virtualRows.length - 1]).end,
        ]
      : [0, 0];
  return {
    virtualRows,
    before,
    after,
    measureElement: rowVirtualizer.measureElement,
    scrollToIndex: rowVirtualizer.scrollToIndex,
  };
};
